import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {createFormButtonActionHandler} from '../../util';

import LoanAmountForm from './LoanAmountForm';
import RepaymentDurationForm from './RepaymentDurationForm';
import LoanInformationModal from './LoanInformationModal';
import PersonalLoansResultCard from './PersonalLoansResultsCard';
import OmButton from '../forms/OmButton';

import {
    backRepaymentDurationDetails,
    calculateLoanResults,
} from '@om/redux/actions/personalLoansCalculator/calculator';
import {getApplicableRepaymentTerms} from '@om/redux/actions/personalLoansCalculator/referenceData';
import {
    getCalculateButtonDisabled,
    getCalculator,
    getNavigationButtonDisabled,
    getNavigationButtonText,
} from '@om/redux/selectors/personalLoansCalculator/calculator';
import {getScrollToId} from '@om/redux/selectors/personalLoansCalculator/scrolling';
import { OmPersonalLoansCalculator } from '@om/component-library-react';

const PersonalLoansCalculator = ({
    uid,
    isInContainer,
    onCompleteEvent,
    slot,
}) => {

    const dispatch = useDispatch();

    const {
        calculator,
        calculateButtonDisabled,
        navigationButtonDisabled,
        navigationButtonText,
        scrollToId,
    } = useSelector(
        createStructuredSelector({
            calculator: getCalculator,
            calculateButtonDisabled: getCalculateButtonDisabled,
            navigationButtonDisabled: getNavigationButtonDisabled,
            navigationButtonText: getNavigationButtonText,

            scrollToId: getScrollToId,
        })
    );

    const navigationButtonHandler = () => {
        if (!calculator.showLoanRepaymentDurationForm) {
            dispatch(getApplicableRepaymentTerms());
        } else if (calculator.showLoanRepaymentDurationForm) {
            dispatch(backRepaymentDurationDetails());
        }
    }

    const onCalculateEventHandler = () => {
        dispatch(calculateLoanResults());
        onCompleteEvent && onCompleteEvent();
    }

    return (
        <OmPersonalLoansCalculator
            id={uid}
            slot={slot}
            scrollToId={scrollToId}
            isInContainer={isInContainer}
        >
            <div slot="calculator-form">
                <form>
                    {!calculator.showLoanRepaymentDurationForm ? <LoanAmountForm/> : <RepaymentDurationForm/>}
                </form>
            </div>
            <div slot="navigation-buttons-web">
                <OmButton
                    text={navigationButtonText}
                    type="secondary"
                    size="large"
                    disabled={navigationButtonDisabled}
                    onClick={() =>  navigationButtonHandler()}/>
                {
                    calculator.showLoanRepaymentDurationForm
                    && <div className="continue-section">
                        <OmButton
                            text="Calculate"
                            type="primary"
                            size="large"
                            disabled={calculateButtonDisabled}
                            onClick={() => onCalculateEventHandler() }/>
                        {
                            calculator.showResultsSummaryCard
                            && <h6 className="small" slot="navigation-button-disclaimer">
                                <span className="medium">Note:</span>
                                The repayment amount is only an estimate and includes credit life insurance and service
                                fees </h6>
                        }
                    </div>
                }
            </div>
            <div slot="navigation-buttons-mobile">
                <OmButton
                    text={navigationButtonText}
                    type="secondary"
                    size="small"
                    disabled={navigationButtonDisabled}
                    onClick={() =>  navigationButtonHandler()}/>
                {
                    calculator.showLoanRepaymentDurationForm
                    && <div className="continue-section">
                        <OmButton
                            text="Calculate"
                            type="primary"
                            size="small"
                            disabled={calculateButtonDisabled}
                            onClick={() => onCalculateEventHandler()}/>
                    </div>
                }
            </div>
            <div slot="result-card">
                {
                    calculator.showResultsSummaryCard && <PersonalLoansResultCard/>
                }
                <LoanInformationModal/>
            </div>
        </OmPersonalLoansCalculator>
    )
}

export default PersonalLoansCalculator;
